import jobStatus from "../../../shared/variables/job-status";

import {
  SEARCH_GOLFER,
  SEARCH_GOLFER_SUCCESS,
  SEARCH_GOLFER_FAILED,
} from "../actions";

const initialState = {
  status: jobStatus.NOT_STARTED,
  error: undefined,
  golfers: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SEARCH_GOLFER:
      return {
        ...state,
        status: jobStatus.PROCESSING,
        golfers: [],
      };
    case SEARCH_GOLFER_SUCCESS: {
      return {
        ...state,
        golfers: payload.golfers,
        status: jobStatus.SUCCESS,
      };
    }
    case SEARCH_GOLFER_FAILED: {
      return {
        ...state,
        status: jobStatus.FAILED,
        error: payload,
      };
    }
    default:
      return state;
  }
};
